import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/custom/Navbar";
import Footer from "./components/custom/Footer";
import Home from "./pages/Home";
import TeamPage from "./pages/TeamPage";
import Podcast from "./pages/Podcast";
import Admin from "./pages/Admin";
import ArticlePage from "./pages/ArticlePage";
import DCSoccer from "./pages/DCSoccer";
import CommandersPage from "./pages/CommandersPage";
import StaticPage from "./pages/StaticPage";
import NotFound from "./pages/NotFound";
import Scores from "./pages/Scores";
import ScoreBar from "./components/custom/ScoreBar";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <ScoreBar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/scores" element={<Scores />} />
            <Route path="/commanders" element={<CommandersPage />} />
            <Route path="/capitals" element={<TeamPage teamKey="capitals" />} />
            <Route path="/nationals" element={<TeamPage teamKey="nationals" />} />
            <Route path="/wizards" element={<TeamPage teamKey="wizards" />} />
            <Route path="/mystics" element={<TeamPage teamKey="mystics" />} />
            <Route path="/podcast" element={<Podcast />} />
            <Route path="/dcunited" element={<TeamPage teamKey="dcunited" />} />
            <Route path="/spirit" element={<TeamPage teamKey="spirit" />} />
            <Route path="/defenders" element={<TeamPage teamKey="defenders" />} />
            <Route path="/dcsoccer" element={<DCSoccer />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/article/:articleId" element={<ArticlePage />} />
            <Route path="/about" element={<StaticPage />} />
            <Route path="/contact" element={<StaticPage />} />
            <Route path="/privacy" element={<StaticPage />} />
            <Route path="/editorial-standards" element={<StaticPage />} />
            <Route path="/corrections" element={<StaticPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
